import { useEffect, useRef, useState } from 'react';
import {
  Button,
  Image,
  Form,
  Header,
  Icon,
  Input,
  Segment,
} from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import './styles.css';
import {
  errorEmptyText,
  errorMessageText,
} from '../../app/common/form/errorMessageText';
import { observer } from 'mobx-react-lite';
import { ThreeDotLoader } from '../../app/layout/LoadingComponent';
import UnauthorizedMessage from '../UnauthorizedMessage';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';

function RolesAndPermissions() {
  const { RolesPermissionsStore, dashboardStore, commonStore } = useStore();

  const {
    rolesPermissions,
    getRolesPermissionsDetails,
    selectedRoleId,
    updateMode,
  } = RolesPermissionsStore || {};

  const [name, setName] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  const inputRef = useRef<HTMLInputElement | null>(null);
  const cancelAPIRef = useRef<any>({});

  useEffect(() => {
    // eslint-disable-next-line
    return () => {
      RolesPermissionsStore.rolesPermissions = {};
      RolesPermissionsStore.selectedRoleId = '';
      RolesPermissionsStore.timeCalculate = {};
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let timer = setTimeout(() => {
      setErrorMessage('');
    }, 2000);

    return () => clearTimeout(timer);
  }, [errorMessage]);

  useEffect(() => {
    let payload = {
      roleId: '',
      id: '',
      title: '',
    };
    getRolesPermissionsDetails(payload, cancelAPIRef);
    // eslint-disable-next-line
  }, []);

  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      addNewHandler();
    }
  };

  const cardClickHandler = (
    id: string,
    name: string,
    title: string,
    index: number,
  ) => {
    if (title === 'ROLES') RolesPermissionsStore.selectedRoleId = id;

    let rolesList = Object.keys(RolesPermissionsStore.rolesPermissions) || 0;

    for (let i = index || 0; i < (rolesList || [])?.length; i++) {
      if (!rolesList?.length) return;
      let title = rolesList[i + 1];
      delete RolesPermissionsStore.rolesPermissions[title];
    }

    RolesPermissionsStore.rolesPermissions[`${title}`] = {
      ...RolesPermissionsStore.rolesPermissions[`${title}`],
      selectedId: id,
    };

    let localId = title === 'ROLES' ? '' : id;

    if (title === 'METADATA/TEMPLATE') {
      let localTitle = rolesList[index - 1];
      localId =
        RolesPermissionsStore.rolesPermissions[`${localTitle}`].selectedId;
    }

    let payload = {
      roleId: title === 'ROLES' ? id : selectedRoleId,
      id: localId,
      title:
        title === 'TYPES' || title === 'METADATA/TEMPLATE' || title === 'RULES'
          ? name
          : title,
    };

    getRolesPermissionsDetails(payload, cancelAPIRef, id, title, index);
  };

  const modeHandler = (
    frontendId: string,
    title: string,
    index: number,
    mode: number,
    parentIndex: number,
  ) => {
    let rolesList = Object.keys(RolesPermissionsStore.rolesPermissions) || 0;
    for (let i = parentIndex || 0; i < (rolesList || [])?.length; i++) {
      if (!rolesList?.length) return;
      let title = rolesList[i + 1];
      delete RolesPermissionsStore.rolesPermissions[title];
    }

    if (RolesPermissionsStore?.rolesPermissions?.[`${title}`]?.data?.[index]) {
      RolesPermissionsStore.rolesPermissions[`${title}`].data[index].mode =
        mode;
    }

    let payload = {
      frontEndId: frontendId,
      mode,
      roleId: selectedRoleId,
    };
    updateMode(payload);
    // static condition for audio player and preview auto disable.
    if (!['AVLAVB17', 'AVLAVB16'].includes(frontendId)) return;
    if (['AVLAVB17', 'AVLAVB16'].includes(frontendId) && mode === 1) {
      let payload = {
        frontEndId: frontendId === 'AVLAVB16' ? 'AVLAVB17' : 'AVLAVB16',
        mode: 2,
        roleId: selectedRoleId,
      };
      setTimeout(async () => {
        updateMode(payload);
        const payload1 = {
          roleId: selectedRoleId,
          id: '82313892-cf60-4e6d-a690-71070da90716',
          title: 'PAGES',
        };
        getRolesPermissionsDetails(
          payload1,
          { current: {} },
          '82313892-cf60-4e6d-a690-71070da90716',
          'PAGES',
          2,
        );
      }, 500);
    }
  };

  const addNewHandler = async () => {
    let findIndex = rolesPermissions[`ROLES`]?.data.findIndex(
      (d) => d.name === name,
    );

    if (findIndex !== -1) {
      setErrorMessage(errorMessageText.content);
      return;
    }
    if (name?.length === 0) {
      setErrorMessage(errorEmptyText.content);
      return;
    }

    let id = await RolesPermissionsStore.createNewRole({ roleName: name });

    RolesPermissionsStore.rolesPermissions[`ROLES`].data.push({
      id,
      name,
    });

    setName('');
    setErrorMessage('');
  };

  const cloneHandler = async () => {
    let findIndex = rolesPermissions[`ROLES`]?.data.findIndex(
      (d) => d.name === name,
    );

    if (findIndex !== -1) {
      setErrorMessage(errorMessageText.content);
      return;
    }
    if (name?.length === 0) {
      setErrorMessage(errorEmptyText.content);
      return;
    }

    let id = await RolesPermissionsStore.cloneRole({
      roleName: name,
      roleId: selectedRoleId,
    });

    RolesPermissionsStore.rolesPermissions[`ROLES`].data.push({
      id,
      name,
    });

    setName('');
    setErrorMessage('');
  };
  const filteredModeAudioAndVideo = (d: any) => {
    if (['AVLAVB17', 'AVLAVB16'].includes(d.frontendId)) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('SRB01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('SRB01') && (
        <div className="roles-permissions-container">
          <div className="roles-permissions-header">
            <Header
              style={{ marginLeft: '20px' }}
              icon="cogs"
              size="huge"
              dividing
              as="h1"
              content={
                (userLanguage[0].Sidebar.M13I01 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              sub
              color="grey"
            />
          </div>
          <div
            style={{
              height: '85vh',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: '20px',
              margin: '12px 10px 0 20px',
            }}
          >
            {Object.values(rolesPermissions)?.map((values, index) => (
              <div
                className="roles-permissions-wrapper"
                style={{ height: `calc(100% - ${(index + 1) * 2}%)` }}
              >
                <Header as="h4" color="blue" style={{ position: 'relative' }}>
                  {values.title}
                  {values.isLoading && <ThreeDotLoader />}
                </Header>
                <div
                  className="roles-permissions-cards-container"
                  style={{
                    height:
                      values.title === 'ROLES'
                        ? 'calc(100% - 156px)'
                        : 'calc(100% - 30px)',
                  }}
                >
                  {!values?.data?.length ? (
                    <Image
                      style={{ margin: 'auto' }}
                      src={'/assets/empty.svg'}
                      alt={'empty'}
                      width={'300px'}
                      height={'300'}
                    />
                  ) : (
                    values.data.map((d, childIndex) => (
                      <div
                        style={{
                          background:
                            (values.selectedId || selectedRoleId) === d.id
                              ? '#f7f7f7'
                              : 'transparent',
                        }}
                        className="roles-permissions-cards-wrapper"
                        onClick={() => {
                          if (d.mode === undefined || d.mode === 1)
                            cardClickHandler(d.id, d.name, values.title, index);
                        }}
                      >
                        <p>{d.name}</p>
                        {d.mode !== undefined && (
                          <div
                            className="icons-wrapper"
                            style={{ minWidth: '67px' }}
                          >
                            {filteredModeAudioAndVideo(d) && (
                              <Icon
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  modeHandler(
                                    d.frontendId || '',
                                    values.title,
                                    childIndex,
                                    0,
                                    index,
                                  );
                                }}
                                name={d.mode === 0 ? 'dot circle' : 'circle'}
                                color={'grey'}
                                style={{ opacity: d.mode === 0 ? '1' : '0' }}
                              />
                            )}
                            <Icon
                              onClick={(e: any) => {
                                e.stopPropagation();
                                modeHandler(
                                  d.frontendId || '',
                                  values.title,
                                  childIndex,
                                  1,
                                  index,
                                );
                              }}
                              name={d.mode === 1 ? 'dot circle' : 'circle'}
                              color={'blue'}
                              style={{ opacity: d.mode === 1 ? '1' : '0' }}
                            />
                            <Icon
                              onClick={(e: any) => {
                                e.stopPropagation();
                                modeHandler(
                                  d.frontendId || '',
                                  values.title,
                                  childIndex,
                                  2,
                                  index,
                                );
                              }}
                              // className='searchInputTooplTip'
                              name={d.mode === 2 ? 'dot circle' : 'circle'}
                              color={'red'}
                              style={{ opacity: d.mode === 2 ? '1' : '0' }}
                            />
                            {/* <Icon
                     onClick={(e: any) => {
                       e.stopPropagation();
                       modeHandler(
                         d.frontendId || '',
                         values.title,
                         childIndex,
                         2,
                         index,
                       );
                     }}
                     name={'info circle'}
                     className='icon-i-color'
                    //  color={'green'}
                   /> */}
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
                {values.title === 'ROLES' && (
                  <Segment>
                    <Form style={{ margin: 0 }}>
                      <Form.Group widths="equal">
                        <Form.Field
                          control={Input}
                          ref={inputRef}
                          error={errorMessage || null}
                          value={name}
                          placeholder={
                            (userLanguage[0].RPModal.RP02 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }
                          onChange={(_e: any, data: any) => setName(data.value)}
                          onKeyDown={handleKeyPress}
                        />
                      </Form.Group>
                    </Form>
                    {
                      <div style={{ display: 'flex' }}>
                        {commonStore.filterModeTwo?.includes('SRPB16') ? (
                          <></>
                        ) : (
                          <Button
                            style={{ width: '100%' }}
                            color="blue"
                            onClick={cloneHandler}
                            className={
                              commonStore.filterModeZero?.includes('SRPB16')
                                ? 'component-isDisabled'
                                : ''
                            }
                            size="small"
                            disabled={
                              // commonStore.filterModeZero.includes('DYDC-CREATE') ||
                              !!errorMessage
                            }
                          >
                            {
                              (userLanguage[0].RPModal.RP01 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                          </Button>
                        )}

                        {commonStore.filterModeTwo?.includes('SRPB14') ? (
                          <></>
                        ) : (
                          <Button
                            style={{ width: '100%' }}
                            color="green"
                            size="small"
                            onClick={addNewHandler}
                            className={
                              commonStore.filterModeZero?.includes('SRPB14')
                                ? 'component-isDisabled'
                                : ''
                            }
                            disabled={
                              // commonStore.filterModeZero.includes('DYDC-CREATE') ||
                              !!errorMessage
                            }
                          >
                            {
                              (userLanguage[0].RPModal.RP02 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                          </Button>
                        )}
                      </div>
                    }
                  </Segment>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default observer(RolesAndPermissions);
